import exportActionType from "./export.types";

export const setExportData = (exportData) => ({
    type: exportActionType.SET_EXPORT_DATA,
    payload: exportData
});
